import script from "./LessonActivity.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonActivity.vue?vue&type=script&setup=true&lang=js"

import "./LessonActivity.vue?vue&type=style&index=0&id=fe263644&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe263644"]])

export default __exports__